export default __webpack_public_path__ + "static/media/Slide25.cfa56922.JPG";